import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { validateRegistry, useAuthStore, useAppStore } from '@indipia/shared';
import { AGENT_REGISTRY } from './registry/agents';
import { router } from './routes';
import '@indipia/styles/globals.css';

validateRegistry(AGENT_REGISTRY);

if (import.meta.env.VITE_DEV_BYPASS_AUTH === 'true') {
  if (!useAuthStore.getState().accessToken) {
    useAuthStore.getState().setAuth({
      accessToken: 'dev-mock-token',
      refreshToken: 'dev-mock-refresh',
      user: { memberId: 1, memberName: '개발자', compId: 1, compName: '테스트회사', masterYn: 'Y' },
    });
  }
  if (!useAppStore.getState().initLoaded) {
    useAppStore.getState().setInit({
      studioId: 1,
      studioStage: 3,
      profileImgUrl: null,
      subscriptions: [
        { agentSubId: 1, agentId: 2, agentName: '인디공사현황', agentType: 'work-log', iconUrl: null, recommendTitle: null, recommendDesc: null, agentOrder: null, createdAt: '' },
        { agentSubId: 2, agentId: 8, agentName: '인디플래너', agentType: 'scheduler', iconUrl: null, recommendTitle: null, recommendDesc: null, agentOrder: null, createdAt: '' },
      ],
      codes: [],
    });
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
